import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import AcademicTermsTable from '../../components/academicTerms/AcademicTermsTable';

const AcademicTermsArchive = () => (
    <WrapperSection>
        <GlobalBreadcrumbs />
        <AcademicTermsTable isArchive />
    </WrapperSection>
);

export default AcademicTermsArchive;
